/**
 * Resolve the tenant subdomain from a hostname.
 * Returns the leftmost label when a subdomain is present, otherwise ''.
 * 'www' is treated as no subdomain.
 *
 * Pure function (no Angular deps) so it can be unit-tested in isolation.
 */
export function extractSubdomain(hostname: string): string {
  const parts = hostname.split('.');
  // Use the subdomain when present (more than 2 parts), otherwise send blank and let the backend decide
  const subdomain = parts.length > 2 ? parts[0] : '';
  // 'www' is not a tenant — treat it as no subdomain
  return subdomain === 'www' ? '' : subdomain;
}

/**
 * True when the hostname is a real domain (has a dot) but carries no tenant
 * subdomain — e.g. the bare apex 'aryzatime.app' or 'www.aryzatime.app'.
 * Single-label hosts like 'localhost' are NOT apex (dev environments).
 */
export function isApexHost(hostname: string): boolean {
  return hostname.includes('.') && extractSubdomain(hostname) === '';
}
